<template>
  <div style="display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 1868.8 1868.8"
    >
      <g>
        <g>
          <path
            :fill="iconColor"
            d="M682.5,997.9h233v239.3H726.6c-24.2,0-44.1-19.9-44.1-44.1V997.9z"
          />
        </g>
        <g>
          <path
            :fill="iconColor"
            d="M1186.3,997.9v195.2c0,24.2-19.9,44.1-44.1,44.1H953.3V997.9H1186.3z"
          />
        </g>
        <g>
          <path
            :fill="iconColor"
            d="M632.2,853.1v63c0,24.2,19.9,44.1,44.1,44.1h6.3h233v-37.8V809H676.3C652.1,809,632.2,828.9,632.2,853.1z"
          />
        </g>
        <g>
          <path
            :fill="iconColor"
            d="M1192.5,809H953.3v113.3v37.8h233h6.3c24.2,0,44.1-19.9,44.1-44.1v-63C1236.6,828.9,1216.7,809,1192.5,809z"
          />
        </g>
        <g>
          <path
            :fill="iconColor"
            d="M934.4,835.3c-5.5,0-10.7-2.4-14.3-6.5c-3.6-4.2-5.2-9.7-4.4-15.1c9.3-63,58.5-182.1,178.1-182.1
            c68.3,0,92.5,36.9,92.5,68.5C1186.3,756.2,1108.1,835.3,934.4,835.3L934.4,835.3z M1093.8,669.4c-90.2,0-124.5,85.8-135.8,127.6
            c71.2-3.3,116.1-21.3,141.9-36.7c35.8-21.3,48.6-45.1,48.6-60.3C1148.5,677.4,1120.2,669.4,1093.8,669.4z"
          />
        </g>
        <g>
          <path
            :fill="iconColor"
            d="M934.4,835.3c-173.7,0-251.9-79.1-251.9-135.2c0-31.6,24.2-68.5,92.5-68.5c119.6,0,168.7,119.1,178.1,182.1
            c0.8,5.4-0.8,11-4.4,15.1C945.2,832.9,939.9,835.3,934.4,835.3L934.4,835.3z M775.1,669.4c-26.4,0-54.7,8.1-54.7,30.7
            c0,32.2,56.2,90.8,190.5,96.9C899.5,755.2,865.2,669.4,775.1,669.4L775.1,669.4z"
          />
        </g>
      </g>
      <g>
        <path
          :fill="iconColor"
          d="M934.4,1868.4c-22.8,0-45.6-8.5-63.4-25.4l-0.7-0.7l-54.9-54.9c-25.6-25.7-63.7-33.2-97.2-19.3l-71.8,29.8
          c-46.1,19.1-99.2-2.8-118.4-49l-29.9-72.3c-13.8-33.5-46-55-82.2-55c-0.1,0-0.1,0-0.2,0h-78h-0.1c-49.8,0-90.5-40.5-90.6-90.4
          v-77.7c0.1-36.3-21.5-68.6-55-82.4l-71.8-29.7c-22.3-9.2-39.8-26.6-49.1-49c-9.3-22.3-9.3-46.8-0.2-69.1l0.4-0.9l29.6-71.4
          c13.9-33.5,6.3-71.6-19.3-97.2l-55.3-55.5c-35.2-35.3-35.2-92.8,0-128.1l54.9-54.9c25.7-25.6,33.3-63.8,19.3-97.2l-29.7-71.7
          c-19.1-46.1,2.8-99.2,48.9-118.4l72.2-29.9c33.5-13.8,55.1-46.2,55-82.4v-78c0.1-49.9,40.7-90.5,90.5-90.6h77.7c0.1,0,0.1,0,0.2,0
          c36.2,0,68.5-21.6,82.2-55l29.7-71.8c18.9-45.9,71.6-68,117.6-49.5l2.1,0.9l70.7,29.2c33.5,14,71.6,6.4,97.2-19.2L871,25.8
          c35.5-33.9,91.2-33.9,126.8,0l0.7,0.7l54.9,54.9c25.6,25.8,63.8,33.3,97.2,19.4l71.8-29.8c46.1-19.1,99.2,2.8,118.4,48.9l0.1,0.2
          l29.9,71.9c13.8,33.5,46,55.1,82.2,55.1c0.1,0,0.1,0,0.2,0h78.1c49.9,0.1,90.5,40.7,90.6,90.6v77.7c0,36.2,21.6,68.5,55,82.3
          l71.9,29.8c45.8,18.9,67.9,71.4,49.5,117.3l-0.4,1.1L1768,718c-13.9,33.5-6.3,71.6,19.3,97.1l55.2,55.2
          c35.3,35.3,35.3,92.8,0,128.1l-54.9,54.9c-25.7,25.6-33.2,63.7-19.3,97.2l29.8,71.8c18.9,45.6-2.3,98.1-47.4,117.7l-0.8,0.4
          l-1.4,0.5l-71.4,29.6c-33.5,13.8-55.1,46.2-55,82.4v78c-0.1,49.9-40.7,90.5-90.6,90.6h-77.8c-0.1,0-0.1,0-0.2,0
          c-36.2,0-68.5,21.6-82.3,55l-29.7,71.8c-9.2,22.3-26.5,39.8-48.9,49.1c-22.2,9.3-46.6,9.4-68.9,0.3l-0.5-0.2l-72.1-29.7
          c-33.6-14-71.7-6.4-97.2,19.2l-55.9,55.9C980,1859.9,957.2,1868.4,934.4,1868.4z M929.2,1782.3c3,2.6,7.4,2.6,10.3,0l54.7-54.7
          c49.7-49.8,123.9-64.5,188.9-37.4l72,29.7c2.1,0.9,3.9,0.5,5,0s2.7-1.5,3.5-3.6l29.7-71.8c26.8-65,89.5-107,159.9-107
          c0.1,0,0.2,0,0.3,0h77.6c3.6,0,6.6-3,6.6-6.6V1453c-0.1-70.4,41.9-133.2,107-160.1l70.6-29.3l0.6-0.3l1.1-0.4
          c1.8-0.9,2.8-2.3,3.2-3.4c0.5-1.1,0.9-3,0-5l-29.7-71.7c-27.1-64.9-12.4-139.1,37.5-188.9l54.8-54.8c2.6-2.6,2.6-6.8,0-9.3
          l-55.1-55.1c-49.9-49.7-64.6-123.8-37.6-188.9l29.9-72c1.4-3.3-0.2-7.2-3.6-8.6l-71.8-29.7c-65-26.8-107.1-89.6-107-160v-77.6
          c0-3.6-3-6.6-6.7-6.6h-78c-0.1,0-0.2,0-0.3,0c-70.2,0-132.9-42-159.7-107L1263,152c-1.3-3.2-5.2-4.8-8.5-3.4l-71.7,29.7
          c-65,27.1-139.2,12.4-189-37.6l-54.3-54.3c-3-2.6-7.4-2.6-10.4,0l-54.7,54.7c-49.7,49.8-123.9,64.5-188.9,37.4L614.2,149l-1.4-0.5
          c-3.2-0.9-6.6,0.7-7.9,3.9l-29.7,71.7c-26.8,65-89.5,107-159.8,107c-0.1,0-0.2,0-0.3,0h-77.5c-3.6,0-6.6,3-6.6,6.7v77.9
          c0.1,70.4-41.9,133.2-107,160.1l-72,29.9c-3.4,1.4-5,5.2-3.6,8.6l29.6,71.6c27.1,64.9,12.4,139.1-37.5,188.9l-54.8,54.8
          c-2.6,2.6-2.6,6.8,0,9.3l55.2,55.4c49.8,49.6,64.6,123.8,37.5,188.8l-29.9,72.3c-0.7,1.9-0.3,3.6,0.1,4.7c0.5,1.1,1.5,2.7,3.6,3.5
          l71.7,29.7c65.1,26.8,107.2,89.7,107,160.2v77.4c0,3.6,3,6.6,6.6,6.6l0,0h78c0.1,0,0.2,0,0.3,0c70.2,0,133,42,159.8,107l30,72.5
          c1.5,3.1,5.2,4.6,8.4,3.2l71.7-29.7c65-27.1,139.2-12.4,188.9,37.5L929.2,1782.3z"
        />
      </g>
      <g>
        <path
          :fill="iconColor"
          stroke-width="13"
          stroke-miterlimit="10"
          :stroke="iconColor"
          d="M1360.6,508.2c-113.8-113.8-265.2-176.5-426.2-176.5s-312.3,62.7-426.2,176.5c-22.6,22.6-43.2,46.8-61.7,72.1
          h51c103.2-127.2,260.7-208.6,436.9-208.6s333.7,81.4,436.9,208.6h50.9C1403.8,555,1383.2,530.9,1360.6,508.2z M1371.3,1288.4
          c-103.2,127.2-260.8,208.6-436.9,208.6s-333.7-81.4-436.9-208.6h-51c18.5,25.4,39.1,49.5,61.7,72.1
          C622,1474.3,773.4,1537,934.4,1537s312.3-62.7,426.2-176.5c22.6-22.6,43.3-46.8,61.7-72.1H1371.3z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";

export default {
  name: "CollectionsIcon",
  mixins: [globals],
  props: {
    size: {
      type: [String, Number],
      default: 30
    },
    color: {
      type: String,
      default: null
    },
    bgColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return false;
    },
    iconColor() {
      const baseColor = this.color || this.isDescriptionColour || this.bgTheme || '#585957';
      const background = this.bgColor || this.shadowBgColor;

      if (this.isDarkTheme && background && this.areColorsSimilar(baseColor, background)) {
        return this.lightenColor(baseColor, 40);
      }
      return baseColor;
    }
  },
  methods: {
    hexToRgb(hex) {
      if (!hex) return null;
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return { r, g, b };
    },
    areColorsSimilar(color1, color2, threshold = 60) {
      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);
      if (!rgb1 || !rgb2) return false;

      const distance = Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
        Math.pow(rgb1.g - rgb2.g, 2) +
        Math.pow(rgb1.b - rgb2.b, 2)
      );
      return distance < threshold;
    },
    lightenColor(hex, percent) {
      const rgb = this.hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * (percent / 100)));
      const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * (percent / 100)));
      const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * (percent / 100)));

      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
    }
  }
};
</script>
